import { render, staticRenderFns } from "./InviteMain.vue?vue&type=template&id=4db9b81b&scoped=true&"
import script from "./InviteMain.vue?vue&type=script&lang=js&"
export * from "./InviteMain.vue?vue&type=script&lang=js&"
import style0 from "./InviteMain.vue?vue&type=style&index=0&id=4db9b81b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9b81b",
  null
  
)

component.options.__file = "InviteMain.vue"
export default component.exports